import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getAddPostKey, POSTS_KEY, FEED_KEY } from '../../utils/keys';
import { addPostToPaginatedPost } from '../cache/useCachedPost';
const spacePostsKey = (spaceId) => ({
    active: true,
    predicate: query => {
        var _a, _b;
        const [main, args] = query.queryKey || [];
        return (main === FEED_KEY ||
            (main === POSTS_KEY && ((_b = (_a = args) === null || _a === void 0 ? void 0 : _a.spaceIds) === null || _b === void 0 ? void 0 : _b.indexOf(spaceId)) > -1));
    },
});
export const useAddPost = (options) => {
    const { useMutationOptions, fields = 'default' } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    const addPostKey = getAddPostKey();
    return useMutation((input) => client.posts.create(input, fields), {
        mutationKey: addPostKey,
        onSuccess: (data, variables) => {
            queryClient.setQueriesData(spacePostsKey(variables.spaceId), addPostToPaginatedPost(data));
        },
        onSettled: (data, error, variables) => {
            queryClient.invalidateQueries(spacePostsKey(variables.spaceId));
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useAddPost.js.map